import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import { AuthContext } from "context";
import MDAlert from "../../components/MDAlert";
import MDTypography from "../../components/MDTypography";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import GenericForm from "../genericForm";
import apiService from "../../services/api-service";
import showToast from "../../utils/toast";
import toast from "react-hot-toast";

function EditMachinery() {
	const authContext = useContext(AuthContext);
	const navigate = useNavigate();
	const { id } = useParams();
	const [suppliers, setSuppliers] = useState([]);
	const [availableAreas, setAvailableAreas] = useState([]);
	const [machineryData, setMachineryData] = useState(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		// Carica fornitori (solo per admin)
		if (!localStorage.getItem("supplier")) {
			apiService
				.get("/suppliers-management/", {}, {})
				.then((data) => {
					const supplierOptions = data.map((supplier) => ({
						id: supplier.id,
						name: supplier.name,
					}));
					setSuppliers(supplierOptions);
				})
				.catch((error) =>
					toast.error(
						"Errore durante il caricamento dei fornitori. Riprova più tardi, se l'errore persiste contatta il supporto tecnico indicando l'errore #00093"
					)
				);
		}

		// Carica cantieri disponibili per il fornitore
		apiService
			.get("/machineries-management/", { get_available_areas: true }, {})
			.then((data) => {
				setAvailableAreas(data);
			})
			.catch((error) => 
				toast.error("Errore durante il caricamento dei cantieri disponibili")
			);

		// Fetch machinery data
		apiService
			.get("/machineries-management/", { id }, {})
			.then((data) => {
				const machinery = data[0];
				setMachineryData({
					...machinery,
					supplier: {
						id: machinery.supplier_id,
						name: machinery.supplier_name,
					},
					// Le aree sono già incluse dall'API aggiornata
					areas: machinery.areas || []
				});
				console.log("machineryData...", machineryData);
				setLoading(false);
			})
			.catch((error) => {
				toast.error(
					"Errore durante il caricamento dei dati del macchinario. Riprova più tardi, se l'errore persiste contatta il supporto tecnico indicando l'errore #00094"
				);
			});
	}, [id, navigate]);

	return (
		<>
			<DashboardLayout>
				{authContext.hasAuth("UPDATE_MACHINERY") ? (
					<>
						<DashboardNavbar />
						<MDBox pt={6} pb={3}>
							<MDTypography variant="h6" color="black">
								MODIFICA MACCHINARIO
							</MDTypography>
						</MDBox>

						{!loading && machineryData && (
							<GenericForm
								useAPI={true}
								url="/machineries-management/"
								old_data={machineryData}
								executeOnSuccess={true}
								executeOnSuccessTask={() => {
									toast.success(
										"Macchinario modificato con successo"
									);
									navigate("/machinery-management");
								}}
								inputFields={[
									{
										type: "text",
										label: "Nome",
										name: "name",
										required: true,
									},
									{
										type: "text",
										label: "Numero Telaio",
										name: "chassis_number",
										required: true,
									},
									// Solo mostra il campo fornitore se non è un fornitore (quindi è admin)
									...(localStorage.getItem("supplier") ? [] : [{
										type: "autocomplete",
										label: "Fornitore",
										name: "supplier_id",
										required: true,
										options: suppliers,
										valueToDisplay: (value) => {
											if (typeof value === "object") {
												return value.name;
											}
											const option = suppliers.find(
												(opt) => opt.id === value
											);
											return option
												? option.name
												: "Fornitore non trovato";
										},
										valueToSave: (value) => {
											console.log(
												"valueToSave...",
												value
											);
											if (!value) return null;
											return value.id;
										},
										valueComparator: (option, value) => {
											return option.id === value;
										},
									}]),
									{
										type: "autocomplete",
										label: "Cantieri Disponibili",
										name: "areas",
										required: false,
										multiple: true,
										options: availableAreas,
										getOptionDisabled: (option, selectedValues) => {
											// Disabilita le opzioni già selezionate
											if (Array.isArray(selectedValues)) {
												return selectedValues.some(selected => {
													if (typeof selected === "number") return selected === option.id;
													if (typeof selected === "object") return selected.id === option.id;
													return false;
												});
											}
											return false;
										},
										valueToDisplay: (value, options) => {
											// Caso singolo oggetto (per getOptionLabel nel dropdown)
											if (value && !Array.isArray(value)) {
												if (typeof value === "object") return value.name;
												const option = options.find(opt => opt.id === value);
												return option ? option.name : "Cantiere non trovato";
											}
											
											// Caso array (per valori selezionati)
											if (Array.isArray(value)) {
												return value.map(v => {
													if (typeof v === "object") return v.name;
													const option = options.find(opt => opt.id === v);
													return option ? option.name : "Cantiere non trovato";
												}).join(", ");
											}
											
											return "";
										},
										valueToSave: (value) => {
											if (Array.isArray(value)) {
												return value.map(v => v?.id || v);
											}
											return [];
										},
										valueComparator: (option, value) => {
											// Per multi-select, value può essere sia l'oggetto singolo che dobbiamo comparare
											// sia parte di un array già selezionato
											if (typeof value === "number") {
												return option.id === value;
											}
											if (typeof value === "object" && value !== null) {
												return option.id === value.id;
											}
											return false;
										},
									},
								]}
							/>
						)}
					</>
				) : (
					<MDAlert color="error" dismissible>
						<MDTypography variant="body2">
							Non hai i permessi per accedere a questa pagina
						</MDTypography>
					</MDAlert>
				)}
			</DashboardLayout>
		</>
	);
}

export default EditMachinery;
